<template>
  <v-page-content>
    <training-step editMode></training-step>
  </v-page-content>
</template>

<script>
import TrainingStep from '@/components/content/education/training/TrainingStep.vue'

export default {
  name: 'TrainingStageChecking',
  components: {
    TrainingStep
  }
}
</script>

<style scoped>

</style>
